<template>
  <portal v-if="isVisible" append :to="`modal-draggable-${id}`">
    <div
      ref="draggablePopupRef"
      class="draggable-popup"
      :style="{ top: `${position.y}px`, left: `${position.x}px`, zIndex }"
      @mousedown.capture="bringToFront"
    >
      <div class="popup-header" :class="variant" @mousedown="startDragging" @mouseup="stopDragging">
        <span>{{ title }}</span>
        <i class="icon-outline_more-horizontal popup-header__drag" />
        <div class="popup-header-actions">
          <slot name="badge"></slot>
          <i class="icon-outline_close popup-header__close" @click="closePopup" />
        </div>
      </div>
      <div class="popup-content" :class="{ scrollable: scrollable }">
        <slot></slot>
      </div>
      <div v-if="$slots.footer" class="popup-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </portal>
</template>

<script>
const zIndexManager = {
  currentZIndex: 131,
  getNextZIndex() {
    return this.currentZIndex++
  },
}
export default {
  props: {
    id: { type: [String, Number], default: '' },
    title: { type: String, default: '' },
    initialX: { type: Number, default: 100 },
    initialY: { type: Number, default: 100 },
    variant: { type: String, default: 'danger' },
    scrollable: { type: Boolean, default: false },
  },
  data() {
    return {
      isVisible: true,
      isDragging: false,
      offset: { x: 0, y: 0 },
      position: { x: this.initialX, y: this.initialY }, // Set initial position from props
      zIndex: 130,
    }
  },
  methods: {
    startDragging(event) {
      this.isDragging = true
      this.offset.x = event.clientX - this.position.x
      this.offset.y = event.clientY - this.position.y
      document.addEventListener('mousemove', this.onDrag)
    },
    stopDragging() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      this.$emit('positionChanged', this.position.x, this.position.y)
    },
    onDrag(event) {
      if (this.isDragging) {
        const element = this.$refs.draggablePopupRef ?? this.$el
        const elementRect = element.getBoundingClientRect()

        const maxX = window.innerWidth - elementRect.width
        const maxY = window.innerHeight - elementRect.height

        const newX = Math.min(Math.max(event.clientX - this.offset.x, 0), maxX)
        const newY = Math.min(Math.max(event.clientY - this.offset.y, 0), maxY)

        this.position.x = newX
        this.position.y = newY
      }
    },
    closePopup() {
      this.isVisible = false
      this.$emit('close', this.id)
    },
    bringToFront() {
      this.zIndex = zIndexManager.getNextZIndex()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
